import * as o from "react";
import r from "../lib/IconBase.es.js";
import s from "../defs/WifiSlash.es.js";
const a = o.forwardRef((i, e) => /* @__PURE__ */ o.createElement(r, { ref: e, ...i, weights: s }));
a.displayName = "WifiSlashIcon";
const m = a;
export {
  m as WifiSlash,
  a as WifiSlashIcon
};
